export default __webpack_public_path__ + "static/media/Slide21.481327b4.jpg";